// Google Ads + gtag conversion tracking for Begum's Biryani Secrets.
// The base Google tag (gtag.js) is loaded once, site-wide, from public/index.html.
// This module only *fires events* through that single tag — no duplicate tags.

export const ADS_ID = "AW-18403382756";

// ─────────────────────────────────────────────────────────────────────────────
// Google Ads Conversion Labels.
// These come from your Google Ads account AFTER you create each conversion action
// (Tools → Conversions → New → Website). Paste the "conversion label" (the part
// after the slash in the snippet, e.g. AW-18403382756/AbCdEf-1234) here.
// Until a label is filled in, that specific event still fires as a standard gtag
// event (useful for GA4), but it will NOT register as a Google Ads conversion.
// ─────────────────────────────────────────────────────────────────────────────
export const CONVERSION_LABELS = {
  purchase: "",            // PRIMARY: "BBS Purchase / Completed Order"
  begin_checkout: "",      // optional secondary
  add_to_cart: "",         // optional secondary
  whatsapp_order_click: "", // optional secondary
  phone_click: "",         // optional secondary
};

function gtag(...args) {
  if (typeof window === "undefined") return;
  if (typeof window.gtag === "function") { window.gtag(...args); return; }
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push(args);
}

// ---- Duplicate-purchase protection (survives page refresh) ----
const FIRED_KEY = "bbs_ga_purchases";
function alreadyFired(id) {
  try { return JSON.parse(localStorage.getItem(FIRED_KEY) || "[]").includes(String(id)); }
  catch { return false; }
}
function markFired(id) {
  try {
    const a = JSON.parse(localStorage.getItem(FIRED_KEY) || "[]");
    if (!a.includes(String(id))) { a.push(String(id)); localStorage.setItem(FIRED_KEY, JSON.stringify(a.slice(-300))); }
  } catch {}
}

function adsConversion(labelKey, params) {
  const label = CONVERSION_LABELS[labelKey];
  if (label) gtag("event", "conversion", { send_to: `${ADS_ID}/${label}`, ...params });
}

// PRIMARY conversion — fire ONLY on a confirmed/paid order. De-duped by transaction_id.
export function trackPurchase({ transactionId, value, currency = "INR" }) {
  if (!transactionId) return false;
  if (alreadyFired(transactionId)) return false;
  markFired(transactionId);
  const val = Number(value) || 0;
  // GA4 ecommerce event (also attributes to Google Ads once the account is linked)
  gtag("event", "purchase", { transaction_id: String(transactionId), value: val, currency });
  // Explicit Google Ads conversion (requires the purchase label)
  adsConversion("purchase", { transaction_id: String(transactionId), value: val, currency });
  return true;
}

// ---- Secondary events (kept separate from purchase) ----
export function trackBeginCheckout(value, currency = "INR") {
  gtag("event", "begin_checkout", { value: Number(value) || 0, currency });
  adsConversion("begin_checkout", { value: Number(value) || 0, currency });
}

export function trackAddToCart(item = {}) {
  gtag("event", "add_to_cart", {
    currency: "INR",
    value: Number(item.value) || 0,
    items: [{ item_id: item.id, item_name: item.name, quantity: item.quantity || 1 }],
  });
  adsConversion("add_to_cart", { value: Number(item.value) || 0, currency: "INR" });
}

export function trackWhatsAppClick() {
  gtag("event", "whatsapp_order_click", { method: "whatsapp" });
  adsConversion("whatsapp_order_click", {});
}

export function trackPhoneClick() {
  gtag("event", "phone_click", { method: "phone" });
  adsConversion("phone_click", {});
}
